export default __webpack_public_path__ + "static/media/menuL_icon_04.089ba711.png";